import { render, staticRenderFns } from "./thumbnailUser.vue?vue&type=template&id=a313ac12&scoped=true&"
import script from "./thumbnailUser.vue?vue&type=script&lang=js&"
export * from "./thumbnailUser.vue?vue&type=script&lang=js&"
import style0 from "./thumbnailUser.vue?vue&type=style&index=0&id=a313ac12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a313ac12",
  null
  
)

export default component.exports